import { CostItemUI } from '../../../types/cost/CostGetResponse';
import EditAndDeleteButton from '../../../components/button/EditAndDeleteButton';

interface RenderCostRowProps {
  item: CostItemUI;
  editingId: number | null;
  onEditButtonClick: (item: CostItemUI) => void;
  onDeleteButtonClick: (item: CostItemUI) => void;
}

const RenderCostRow = ({
  item,
  editingId,
  onEditButtonClick,
  onDeleteButtonClick,
}: RenderCostRowProps) => {
  return (
    <>
      <td>{item.category}</td>
      <td>{item.detail}</td>
      <td>{new Date(item.date).toLocaleDateString('ja-JP')}</td>
      <td>
        {item.price.toLocaleString('ja-JP', { maximumFractionDigits: 2 })}
      </td>
      <td className="text-center" style={{ verticalAlign: 'middle' }}>
        <EditAndDeleteButton
          onEdit={() => onEditButtonClick(item)}
          onDelete={() => onDeleteButtonClick(item)}
          editingRowIndex={editingId}
        />
      </td>
    </>
  );
};

export default RenderCostRow;
